export default "__VITE_ASSET__BA1RC95$__"